/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-undef */
import _ from 'lodash'
import URI from 'urijs'
import React, { useEffect } from 'react'
import { CSSTransition } from 'react-transition-group'
import { useTranslation } from 'react-i18next'
import { useSystemSettings } from 'react-omnitech-api'
import { useCouponMarketplace, useModal, useShare } from '../../hook'
import { useThemeConfig } from '../../hook/use-theme-config'
import { useAlert } from '../../hook/use-alert'
import useI18n from '../../hook/use-i18n'
import useStyles from './mini-cart-coupons-style'
import Loading from '../loading'
import {
  CouponMarketplaceCouponDetail,
  CouponMarketplaceCouponTokenDetail,
  CouponMarketplaceCouponTokensGroupByCoupon,
  CouponMarketplacePopup,
  CouponMarketplaceTabs,
  CouponMarketplaceModal,
} from './components/index'

export default function MiniCartCouponView({
  cartCouponTokens,
  onApplyCouponWithCouponMarketplace,
  isOutsideCheckout,
}) {
  const {
    canSelfUse,
    coupon,
    coupons,
    couponToken,
    couponTokens,
    couponTokensGroupByCoupon,
    couponUsage,
    hasMoreCoupons,
    hasMoreCouponTokens,
    hasMoreCouponTokensGroupByCoupon,
    isCouponDetailOpen,
    isCouponMarketplaceOpen,
    isCouponRedeemed,
    isCouponsReady,
    isCouponTokenDetailOpen,
    isCouponTokensGroupByCouponOpen,
    isCouponTokensGroupByCouponReady,
    isCouponTokensReady,
    isDetailReady,
    isLoading,
    isModalOpen,
    isPopupOpen,
    modalContent,
    onApplyCoupon,
    onApplyCouponError,
    onApplyCouponSuccess,
    onCouponDetailClose,
    onCouponDetailOpen,
    onCouponMarketplaceClose,
    onCouponTokensGroupByCouponClose,
    onFetchCouponsNextPage,
    onFetchCouponTokensGroupByCouponNextPage,
    onFetchCouponTokensNextPage,
    onPopupClose,
    onRedeemCoupon,
    onRequireCouponSecret,
    onShare,
    onTransferIn,
    onTransferOut,
    onTransferUndo,
    popupMessage,
    secretQrCodeValue,
    shareLoading,
    showQrCode,
    showQrCodeMask,
    showSecretQrCode,
    transferLoading,
    userCurrentPoints,
  } = useCouponMarketplace()
  const alert = useAlert()
  const modal = useModal()
  const { share } = useShare()
  const { t } = useTranslation()
  const { getSystemSetting } = useSystemSettings()
  const { getConfig } = useThemeConfig()
  const { currentLocale } = useI18n()

  const enableQrCodeClock = getConfig('config.ui.minicartCoupons.couponDetail.qrcode.enableClock', false)
  const enableQrCodeValue = getConfig('config.ui.minicartCoupons.couponDetail.qrcode.enableValue', false)

  const ecomUri = new URI(getSystemSetting('frontend.site_url', ''))
  const ecomOrigin = ecomUri.origin()

  const isTransferable = _.get(
    couponToken,
    'coupon.isTransferable',
    _.get(coupon, 'isTransferable', false),
  )
  const isShareable = !_.isEmpty(ecomOrigin)
    && _.get(couponToken, 'coupon.meta.shareable', false)
  const appUrl = getSystemSetting('frontend.app_url')

  /**
   * handleError
   * show error message via alert
   */
  function handleError(error) {
    const generalError = _.get(error, 'generalError', {})
    alert.show(generalError.message, { state: 'error' })
  }

  const handleApplyCoupon = async (couponTokenToken) => {
    try {
      onApplyCoupon()
      await onApplyCouponWithCouponMarketplace(couponTokenToken)
      onApplyCouponSuccess()
    } catch (error) {
      onApplyCouponError(error)
    }
  }

  const handleRequireCouponSecret = () => {
    const key = isTransferable ? 'requireTransferableCouponSecret' : 'requireCouponSecret'
    modal.open({
      title: t(`ui.minicartCoupons.modalDialog.${key}.title`),
      message: t(`ui.minicartCoupons.modalDialog.${key}.text`),
      buttons: [
        {
          text: t(`ui.minicartCoupons.modalDialog.${key}.buttons.confirm`),
          onClick: () => {
            // close modal
            modal.close()
            onRequireCouponSecret()
          },
        },
        {
          text: t(`ui.minicartCoupons.modalDialog.${key}.buttons.dismiss`),
          onClick: () => modal.close(),
        },
      ],
    })
  }

  const handleTransfer = (type) => {
    switch (type) {
      case 'in':
        onTransferIn()
          .then(({ id }) => {
            onCouponDetailClose()
            onCouponDetailOpen({
              id,
              type: 'couponToken',
            })
          })
        break;
      case 'out':
        onTransferOut()
          .then(({ transferToken }) => {
            handleCouponTokenTransfer({ transferToken })
          })
          .catch((error) => {
            handleError(error)
          })
        break;
      case 'undo':
        onTransferUndo()
        break;

      default:
        break;
    }
  }

  const handleResendTransferMessage = () => {
    handleCouponTokenTransfer()
  }

  const handleCouponTokenTransfer = ({
    transferToken: tfrTkn,
  } = {}) => {
    const transferToken = tfrTkn || _.get(couponToken, 'transferToken')
    if (_.isEmpty(transferToken)) return
    share({
      modalDialogMessage: t('ui.minicartCoupons.modalDialog.transferOut.text'),
      modalDialogTitle: t('ui.minicartCoupons.modalDialog.transferOut.title'),
      message: t('ui.minicartCoupons.share.transferOut.text'),
      title: t('ui.minicartCoupons.share.transferOut.title'),
      url: `${appUrl}/user/coupons/tokens/${_.get(couponToken, 'token')}?transfer=${transferToken}&couponId=${_.get(couponToken, 'coupon.id')}`,
      imageUrl: _.get(couponToken, 'coupon.defaultImage.versions.webSmall')
        || _.get(couponToken, 'coupon.defaultImage.versions.galleryLarge'),
    })
  }
  const handleShare = () => {
    const qrCodeValue = _.get(couponToken, 'qrCodeData.qrCodeValue') || _.get(couponToken, 'qrCodeValue')
    if (_.isEmpty(qrCodeValue)) return
    onShare()
      .then(() => {
        handleCouponTokenShare({ qrCodeValue })
      })
      .catch((errors) => {
        if (_.some(_.get(errors, 'customErrors', []), ['code', 120111])) {
          // coupon_token_already_shared
          handleCouponTokenShare({ qrCodeValue })
        } else if (_.get(errors, 'generalError.code') === 404) {
          // ignore
        } else {
          handleError(errors)
        }
      })
  }
  const handleCouponTokenShare = ({
    qrCodeValue,
  } = {}) => {
    share({
      modalDialogMessage: t('ui.minicartCoupons.modalDialog.shareable.text'),
      modalDialogTitle: t('ui.minicartCoupons.modalDialog.shareable.title'),
      message: t('ui.minicartCoupons.share.shareable.text'),
      title: t('ui.minicartCoupons.share.shareable.title'),
      url: _.join([
        ecomOrigin,
        _.get(currentLocale, 'locale'),
        'public-coupons',
        encodeURIComponent(qrCodeValue),
      ], '/'),
      imageUrl: _.get(couponToken, 'coupon.defaultImage.versions.webSmall')
        || _.get(couponToken, 'coupon.defaultImage.versions.galleryLarge'),
    })
  }

  useEffect(() => {
    document.body.classList[isCouponMarketplaceOpen ? 'add' : 'remove']('modal-open__mini-cart-coupons')
    // if (!isCouponMarketplaceOpen) {
    //   document.body.scrollTop = currenctScrollTop // for safari
    // for IE/Firefox/...others
    //   document.documentElement.scrollTop = currenctScrollTop
    // }
  }, [isCouponMarketplaceOpen])

  useEffect(() =>
    // remove modal-open__mini-cart-coupons class from body when componentDidMount
    () => {
      document.body.classList.remove('modal-open__mini-cart-coupons')
      document.getElementsByTagName('body')[0].setAttribute('style', '')
    },
  [])

  // Styles
  const styles = useStyles()

  return (
    <>
      <CSSTransition
        in={isCouponMarketplaceOpen}
        timeout={300}
        unmountOnExit
        classNames="mini-cart"
      >
        <div className={styles.miniCard}>
          <CouponMarketplaceTabs
            coupons={coupons}
            couponTokens={couponTokens}
            hasMoreCoupons={hasMoreCoupons}
            hasMoreCouponTokens={hasMoreCouponTokens}
            isCouponsReady={isCouponsReady}
            isCouponTokensReady={isCouponTokensReady}
            userCurrentPoints={userCurrentPoints}
            onFetchCouponsNextPage={onFetchCouponsNextPage}
            onFetchCouponTokensNextPage={onFetchCouponTokensNextPage}
          />
          <CouponMarketplaceCouponTokensGroupByCoupon
            isOpen={isCouponTokensGroupByCouponOpen}
            isReady={isCouponTokensGroupByCouponReady}
            couponTokens={couponTokensGroupByCoupon}
            hasMore={hasMoreCouponTokensGroupByCoupon}
            onClose={onCouponTokensGroupByCouponClose}
            onNextPage={onFetchCouponTokensGroupByCouponNextPage}
          />
          <CouponMarketplaceCouponDetail
            coupon={coupon}
            isCouponRedeemed={isCouponRedeemed}
            isDetailOpen={isCouponDetailOpen}
            isDetailReady={isDetailReady}
            isLoading={isLoading}
            userCurrentPoints={userCurrentPoints}
            onCouponDetailClose={onCouponDetailClose}
            onRedeemCoupon={onRedeemCoupon}
            onTransferIn={_.bind(handleTransfer, null, 'in')}
          />
          <CouponMarketplaceCouponTokenDetail
            canSelfUse={canSelfUse}
            showSecretQrCode={showSecretQrCode}
            cartCouponTokens={cartCouponTokens}
            couponToken={couponToken}
            couponUsage={couponUsage}
            secretQrCodeValue={secretQrCodeValue}
            isDetailOpen={isCouponTokenDetailOpen}
            isDetailReady={isDetailReady}
            isLoading={isLoading}
            isOutsideCheckout={isOutsideCheckout}
            isShareable={isShareable}
            shareLoading={shareLoading}
            showClock={enableQrCodeClock}
            showQrCodeMask={showQrCodeMask}
            showQrCode={showQrCode}
            showQrCodeValue={enableQrCodeValue}
            userCurrentPoints={userCurrentPoints}
            transferLoading={transferLoading}
            onApplyCoupon={handleApplyCoupon}
            onCouponDetailClose={onCouponDetailClose}
            onRequireCouponSecret={handleRequireCouponSecret}
            onResendTrnasferMessage={handleResendTransferMessage}
            onShare={handleShare}
            onTransferIn={_.bind(handleTransfer, null, 'in')}
            onTransferOut={_.bind(handleTransfer, null, 'out')}
            onTransferUndo={_.bind(handleTransfer, null, 'undo')}
          />
          <CouponMarketplaceModal
            isModalOpen={isModalOpen}
            onCouponMarketplaceClose={onCouponMarketplaceClose}
            {...modalContent}
          />
          <CouponMarketplacePopup
            isOpen={isPopupOpen}
            message={popupMessage}
            onClose={onPopupClose}
          />
        </div>
      </CSSTransition>
      {
        isCouponMarketplaceOpen && (
          <div className={styles.overlap} onClick={onCouponMarketplaceClose} />
        )
      }
      {
        isLoading && <Loading />
      }
    </>
  )
}
